import { render, staticRenderFns } from "./EmailMarketingTemplate.vue?vue&type=template&id=17732079"
import script from "./EmailMarketingTemplate.vue?vue&type=script&lang=js"
export * from "./EmailMarketingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports